export const text_faculty = `All PhDs
{

A. Rehman Gilal
Assistant Professor (SL)
 a-rehman@iba-suk.edu.pk

Abdul Aziz
Associate Professor
 aziz.memon@iba-suk.edu.pk

Abdul Baseer Buriro
Assistant Professor
 abdul.baseer@iba-suk.edu.pk

Abdul Qadir
Professor
 aqadir@iba-suk.edu.pk

Abdul Sattar Chan
HoD & Associate Professor
 abdul.sattar@iba-suk.edu.pk

Agha Jahanzeb
Assistant Professor
 agha.jahanzeb@iba-suk.edu.pk

Ahmad Waqas
Associate Professor (On Lien)
 ahmad.waqas@iba-suk.edu.pk

Ahmed Ali Shah
Associate Professor (SL)
 ahmedali.shah@iba-suk.edu.pk

Ahsanullah Abro
Associate Professor
 ahsanullah.abro@iba-suk.edu.pk

Ali Hassan Sodhro
Assistant Professor (Study Leave)
 ali.hassan@iba-suk.edu.pk

Altaf Hussain Samo
Professor / Director EDC
 altaf@iba-suk.edu.pk

Barkat Ali Bhayo
Professor (Leave)
 barkat.bhayo@iba-suk.edu.pk

Faheem Gul Gilal
Associate Professor & Director ORIC
 faheem.gul@iba-suk.edu.pk

Faiz Muhammad Khuwaja
Associate Professor
 faiz@iba-suk.edu.pk

Fareed Ahmed Mangi
Professor (On Lien)
 fareed.mangi@iba-suk.edu.pk

Ghulam Mujtaba Shaikh
Professor & HoD
 mujtaba@iba-suk.edu.pk

Gulsher Ali Lund
Associate Professor
 gulsher@iba-suk.edu.pk

Hafiz M Khalid Shafi
Assistant Professor
 khalid.shafi@iba-suk.edu.pk

Irfan Ahmed Rind
Professor (BPS-21 On lien)
 irfan.rind@iba-suk.edu.pk

Javed Ahmed Shahani
Professor
 javed@iba-suk.edu.pk

Javed Hussain
Associate Professor
 javed.brohi@iba-suk.edu.pk

Khalid Ahmed
Associate Professor (SL)
 khalid.ahmed@iba-suk.edu.pk

Khalil Ahmed Channa
Associate Professor
 khalilchanna@iba-suk.edu.pk

M. Abdul Rehman
Dean - Faculty of Science and Information Technology
 rehman@iba-suk.edu.pk

Madad Ali Shah
Professor & Dean
 madad@iba-suk.edu.pk

Manzoor Ali Mirani
Professor
 manzoor@iba-suk.edu.pk

Muhammad Asim Ali
Associate Professor
 asim.samejo@iba-suk.edu.pk

Muhammad Fazeel Anwar
Associate Professor
 fazeel.anwar@iba-suk.edu.pk

Muhammad Shaique
Assistant Professor
 shaiq@iba-suk.edu.pk

Muhammad Yameen Sandhu
Associate Professor
 yameen@iba-suk.edu.pk

Mujeeb-u-Rehman Bhayo
Assistant Professor & Director IA
 mujeeb@iba-suk.edu.pk

Niaz Ahmed Bhutto
Professor & Dean
 niaz@iba-suk.edu.pk

Niaz Hussain Ghumro
Professor(HoD)
 niaz_ghumro@iba-suk.edu.pk

Pervaiz Memon
Professor
 pervaiz@iba-suk.edu.pk

Pro. Sarwar M. Azhar
Professor
 sarwar.azhar@iba-suk.edu.pk

Qamar Uddin Khand
Associate Professor
 qamar@iba-suk.edu.pk

Rida e Zenab
Assistant Professor
 ridaezenab@iba-suk.edu.pk

Rifat Abbas Khan
Assistant Professor
 riffatabbas@iba-suk.edu.pk

Rukhsana Gul
Associate Professor
 rukhsana.gul@iba-suk.edu.pk

Saeed Ahmed Khan
Associate Professor & Director QEC
 saeed.abro@iba-suk.edu.pk

Safeer Hyder
Assistant Professor(SL)
 laghari@iba-suk.edu.pk

Sajid Khan
Assistant Professor (On Lien)
 sajidkhan@iba-suk.edu.pk

Samar Raza Talpur
Director Campuses KK
 samartalpur@iba-suk.edu.pk

Sarfraz Ahmed Dakhan
Professor
 sarfraz@iba-suk.edu.pk

Shah Rukh Hashmi
Assistant Professor
 sr.hashmi@iba-suk.edu.pk

Shahzaman Khan
HOD/Assistant Professor
 shahzaman@iba-suk.edu.pk

Sharjeel Afridi
Associate Professor & HOD
 sharjeel.afridi@iba-suk.edu.pk

Sheeraz Mustafa
Assistant Professor (On Lien)
 sheeraz.mustafa@iba-suk.edu.pk

Sher Muhammad Daudpota
Professor & Director PGS
 sher@iba-suk.edu.pk

Sidrah Ahmed
Assistant Professor
 dr.sidrah@iba-suk.edu.pk

Syed Hassan Ali
Associate Professor and HOD
 hassan.ali@iba-suk.edu.pk

Syed Hyder Ali Muttaqi Shah
Assistant Professor
 syed.hyderali@iba-suk.edu.pk

Syed Mir Muhammad Shah
Pro Vice Chancellor & Professor
 syedmir@iba-suk.edu.pk

Syed Sabir Hussain Bukhari
Assistant Professor (SL)
 sabir@iba-suk.edu.pk

Tariq Aziz
Assistant Professor (Lien)
 tariq.aziz@iba-suk.edu.pk

Ubedullah Memon
Assistant Professor
 ubedullah.memon@iba-suk.edu.pk

Unaeza Alvi
Assistant Professor (On Leave)
 unaeza.alvi@iba-suk.edu.pk

Zafarullah Sahito
Associate Professor & HOD
 zafarullah.sahito@iba-suk.edu.pk

Zahid Hussain Khand
Professor (On Lien)
 zahid@iba-suk.edu.pk

Zarqa Bano
Associate Professor (HoD)
 zarqa.bano@iba-suk.edu.pk

}


Computer Science
{
Zahid Hussain Khand
Professor (On Lien)
zahid@iba-suk.edu.pk

Ghulam Mujtaba Shaikh
Professor & HoD
mujtaba@iba-suk.edu.pk

M. Abdul Rehman
Dean - Faculty of Science and Information Technology
rehman@iba-suk.edu.pk

Muhammad Asif Khan
Assistant Professor
asif.khan@iba-suk.edu.pk

Javed Ahmed Shahani
Professor
javed@iba-suk.edu.pk

Sher Muhammad Daudpota
Professor & Director PGS
sher@iba-suk.edu.pk

Qamar Uddin Khand
Associate Professor
qamar@iba-suk.edu.pk

Muhammad Irshad Nazeer
Assistant Professor
irshad.nazeer@iba-suk.edu.pk

Faheem Akhtar Rajput
Associate Professor
fahim.akhtar@iba-suk.edu.pk

Ahsanullah Abro
Associate Professor
ahsanullah.abro@iba-suk.edu.pk

Raheel Ahmed Memon
Director ICT | Associate Professor
raheelmemon@iba-suk.edu.pk

Ghulam Murtaza Memon
Assistant Professor
gmurtaza@iba-suk.edu.pk

Nahdia Majeed
Assistant Professor (Study Leave)
nahdia@iba-suk.edu.pk

Jawaid Ahmed Siddiqui
Assistant Professor
jawaid@iba-suk.edu.pk

Asif Rajput
Assistant Professor (On Lien)
asifali@iba-suk.edu.pk

Muhammad Ismail Mangrio
Assistant Professor
ismail@iba-suk.edu.pk

A. Rehman Gilal
Assistant Professor (SL)
a-rehman@iba-suk.edu.pk

Hifazat Ali Shah
Assistant Professor (SL)
hifazat@iba-suk.edu.pk

Javed Ali Abbasi .
Lecturer (SL)
javed.abbasi@iba-suk.edu.pk

Riaz Ali Soomro
Lecturer
riaz.khp@iba-suk.edu.pk

Safdar Ali soomro .
Lecturer (SL)
safdarsoomro@iba-suk.edu.pk

Paras Qadir Memon
Assistant Professor
paras.qadir@iba-suk.edu.pk

Nisar Ahmed Siddiqui
Lecturer
nisar.siddiqui@iba-suk.edu.pk

Ali Raza Barket
Research Associate (Study Leave)
a.raza@iba-suk.edu.pk

Saif Hassan
Lecturer
saif.hassan@iba-suk.edu.pk

Syed Asif Raza
Assistant Professor (SL)
asif.shah@iba-suk.edu.pk

Khalid Hussain Asadullah
Lecturer
khalidhussain@iba-suk.edu.pk

Faryal Shamsi
Lecturer
faryal.shamsi@iba-suk.edu.pk

Adil Khan
Lecturer (Study Leave)
adilkhan.kdk@iba-suk.edu.pk

Adil Khan
Lecturer
adilkhan@iba-suk.edu.pk

Ahmad Waqas
Associate Professor (On Lien)
ahmad.waqas@iba-suk.edu.pk

Muhammad Hussain Mughal
Assistant Professor
muhammad.hussain@iba-suk.edu.pk

Abbas Mehdi
Lecturer
abbas.mehdi@iba-suk.edu.pk

Sajid Khan
Assistant Professor (On Lien)
sajidkhan@iba-suk.edu.pk

Sana Fatima
Lecturer
Not found

Shafaq Siddiqi
Lecturer(Study Leave)
Not found
}




Computer System Engineering

{
Abdul Sattar Chan
HoD & Associate Professor
abdul.sattar@iba-suk.edu.pk

Junaid Ahmed
Assistant Professor
j.bhatti@iba-suk.edu.pk

Irfan Mughal
Assistant Professor
irfan.younas@iba-suk.edu.pk

Suresh Kumar
Assistant Professor
suresh@iba-suk.edu.pk

Mumtaz Ali Kaloi
Lecturer
mumtaz.ali@iba-suk.edu.pk

Pirah Noor
Lecturer (Study Leave)
pirah.noor@iba-suk.edu.pk

Irfan Ali Babar
Lecturer (SL)
irfan_ali@iba-suk.edu.pk

Asif Ali
Lab Engineer BPS-17
asif@iba-suk.edu.pk

Umair Ayaz Kamangar
Lecturer (BPS-18)
umair.ayaz@iba-suk.edu.pk
}


Education
{

Irfan Ahmed Rind
Professor (BPS-21 On lien)
irfan.rind@iba-suk.edu.pk

Zafarullah Sahito
Associate Professor & HOD
zafarullah.sahito@iba-suk.edu.pk

Rifat Abbas Khan
Assistant Professor
riffatabbas@iba-suk.edu.pk

Mahmood Ahmed Dool
Assistant Professor
mahmood.dool@iba-suk.edu.pk

Zahid Ali Jatoi
Assistant Professor
zahid.jatoi@iba-suk.edu.pk

Noor Hussain.
Assistant Professor
noorhussain.cc@iba-suk.edu.pk

Sharik Zamir
Assistant Professor
sharik@iba-suk.edu.pk

Dhani Bux Shah
Assistant Professor
dhanibux.sat@iba-suk.edu.pk

Unaeza Alvi
Assistant Professor (On Leave)
unaeza.alvi@iba-suk.edu.pk

Abdul Hameed Kumbhar
Lecturer
hameed.kumbhar@iba-suk.edu.pk

Roshan Ali
Lecturer (SL)
roshan.ali@iba-suk.edu.pk

Gul Muhammad Rind
Assistant Professor-Education Policy and Leadership
gulrind@iba-suk.edu.pk

Aijaz Ali Soomro
Lecturer (Physics)-(SL)
aijazalisoomro@iba-suk.edu.pk

Mukhtiar Ahmed Arain
Lecturer
mukhtiar.ahmed@iba-suk.edu.pk

AL Karim Datoo
Assistant Professor / Consultant
a.datoo@iba-suk.edu.pk

Rabia Shaikh
Lecturer-Chemistry
rabia.shaikh@iba-suk.edu.pk

Syed Tanweer Ahmed
Lecturer
tanweer.ahmed@iba-suk.edu.pk

Ali Nawab
Assistant Professor
ali.nawab@iba-suk.edu.pk

Muhammad Mujtaba Asad
Assistant Professor
m.mujtaba@iba-suk.edu.pk

Khan Zada
Lecturer (Leave)
khan.zada@iba-suk.edu.pk

Kashif Ali
Lecturer (SL)
kashif.kalhoro@iba-suk.edu.pk

Shairoz Ismail
Lecturer
shairoz@iba-suk.edu.pk

Sohail Ahmed Memon
Assistant Professor
sohail.memon@iba-suk.edu.pk

Tariq Ali
Lecturer
tarique.memon@iba-suk.edu.pk

Kamran Hyder
Lecturer
kamranhyder@iba-suk.edu.pk
}

 Electrical Engineering
{
Madad Ali Shah
Professor & Dean
madad@iba-suk.edu.pk

Sharjeel Afridi
Associate Professor & HOD
sharjeel.afridi@iba-suk.edu.pk

Syed Sabir Hussain Bukhari
Assistant Professor (SL)
sabir@iba-suk.edu.pk

Abdul Qadir
Professor
aqadir@iba-suk.edu.pk

Muhammad Yameen Sandhu
Associate Professor
yameen@iba-suk.edu.pk

Muhammad Asim Ali
Associate Professor
asim.samejo@iba-suk.edu.pk

Ali Hassan Sodhro
Assistant Professor (Study Leave)
ali.hassan@iba-suk.edu.pk

Fareed Ahmed Mangi
Professor (On Lien)
fareed.mangi@iba-suk.edu.pk

Abdul Baseer Buriro
Assistant Professor
abdul.baseer@iba-suk.edu.pk

Abdul Aziz
Associate Professor
aziz.memon@iba-suk.edu.pk

Saeed Ahmed Khan
Associate Professor & Director QEC
saeed.abro@iba-suk.edu.pk

Mir Muhammad Lodro
Assistant Professor (Study Leave)
mir.lodro@iba-suk.edu.pk

M. Fayyaz Uddin
Assistant Professor
fayyazuddin@iba-suk.edu.pk

Dr.-Ing. Kashif Hussain
Assistant Professor
kashif.memon@iba-suk.edu.pk

Ghulam Abbas Lashari
Assistant Professor
ghulam.abbas@iba-suk.edu.pk

Khawaja Haider Ali
Assistant Professor
haiderali@iba-suk.edu.pk

Irfan Ahmed
Assistant Professor(SL)
irfan.ahmed@iba-suk.edu.pk

Sohail Ahmed Soomro
Assistant Professor (SL)
sohail.soomro@iba-suk.edu.pk

Jamshed Ahmed Ansari
Assistant Professor
jamshed.ahmed@iba-suk.edu.pk

Aziz Altaf Khuwaja
Assistant Professor
aziz.khuwaja@iba-suk.edu.pk

Safeer Hyder
Assistant Professor(SL)
laghari@iba-suk.edu.pk

Gulsher Ali Lund
Associate Professor
gulsher@iba-suk.edu.pk

Nabeel Siddiqui
Assistant Professor
nabeel.siddiqui@iba-suk.edu.pk

Muhammad Waqas
Assistant Professor(SL)
mwaqas@iba-suk.edu.pk

Afshan Shah .
Lecturer (SL)
afshan.shah@iba-suk.edu.pk

Syeda Warda Taqdees
Lecturer (Study Leave)
warda@iba-suk.edu.pk

Afaque Manzoor Soomro
Assistant Professor
afaque.manzoor@iba-suk.edu.pk

Sunny Katyara
Lecturer (Study Leave)
sunny.katyara@iba-suk.edu.pk

Syed Bilal Raza Tirmizi
Assistant Professor (Study Leave)
bilal.tirmizi@iba-suk.edu.pk

Fida Hussain Memon
Assistant Professor
fida.hussain@iba-suk.edu.pk

Jahangeer Badar Soomro .
Assistant Professor (SL)
jahangir.soomro@iba-suk.edu.pk

Hafiz Mudassir Munir
Assistant Professor
mudassir.munir@iba-suk.edu.pk

Qasim Ali
Assistant Professor
qasim-ali@iba-suk.edu.pk

Ahmed Ali Shah
Associate Professor (SL)
ahmedali.shah@iba-suk.edu.pk

Shoaib Ahmed Shaikh
Lecturer (SL)
shoaibahmed@iba-suk.edu.pk

Abdul Raheem
Assistant Professor (SL)
abdul.raheem@iba-suk.edu.pk

Shakil Ahmed Jiskani
Lecturer (SL)
shakil.jiskani@iba-suk.edu.pk
}


 Faculty Supporting Faculty
English  Islamiat  International Relations
English

{
Ishfaque Ahmed Abbasi
Lecturer
ishfaque@iba-edu.suk.pk

Nasrullah Dharejo
Lecturer (SL)
nasrullah.khp@iba-suk.edu.pk

Zulfiqar Ali Chachar
Assistant Professor
zchachar@iba-suk.edu.pk

Farhan Bhutto
Lecturer

Surhan Fatima
Lecturer
surhan.fatima@iba-suk.edu.pk

Usama Abdul Rahman
Lecturer (English)

Rashid Hussain
Lecturer

Saqif Rafique Ansari
Assistant Professor
saqif.ansari@iba-suk.edu.pk

Bahawal Soomro
Lecturer
bahawal.soomro@gmail.com

Kamran Akhtar Siddiqui
Lecturer
kamran.akhtar@iba-suk.edu.pk

Anjbeen Soomro
Lecturer
anjbeen.soomro@iba-suk.edu.pk
}



Mathematics

{
Javed Hussain
Associate Professor
javed.brohi@iba-suk.edu.pk

Zarqa Bano
Associate Professor (HoD)
zarqa.bano@iba-suk.edu.pk

Ubaidullah
Assistant Professor
ubaidullah@iba-suk.edu.pk

Adnan Rauf
Assistant Professor
adnan.rauf@iba-suk.edu.pk

Sidrah Ahmed
Assistant Professor
dr.sidrah@iba-suk.edu.pk

Rida e Zenab
Assistant Professor
ridaezenab@iba-suk.edu.pk

Syed Hyder Ali Muttaqi Shah
Assistant Professor
syed.hyderali@iba-suk.edu.pk

Zahid Hussain Shaikh
Assistant Professor
zahid_shaikh@iba-suk.edu.pk

Gul Muhammad Shaikh
Lecturer

Muhammad Asif Memon
Lecturer
asif-memon@iba-suk.edu.pk

Amanullah .
Assistant Professor
amanullah@iba-suk.edu.pk

Abid Memon
Lecturer
abid.ali@iba-suk.edu.pk

Irfan Ali
Assistant Professor (SL)
irfan.qureshi@iba-suk.edu.pk

Arfan Hyder
Assistant Professor (SL)
arfan.hyder@iba-suk.edu.pk

Mohammad Shoaib Khan
Lecturer (SL)
shoaib.khan@iba-suk.edu.pk

Nazim Hussain
Assistant Professor
nazim.hussain@iba-suk.edu.pk

Shumaila Ambreen
Lecturer (SL)
shumaila.ambreen@iba-suk.edu.pk

Muhammad Fazeel Anwar
Associate Professor
fazeel.anwar@iba-suk.edu.pk

Barkat Ali Bhayo
Professor (Leave)
barkat.bhayo@iba-suk.edu.pk

Asifa Abbas
Lecturer English (BPS-18)

Abdul Aziz
Lecturer

Umair Khan
Lecturer (Study Leave)
umairkhan@iba-suk.edu.pk

Umar Khan
lecturer

Pervez Ali
Lecturer (SL)
pervez.ali@iba-suk.edu.pk

Raja Fawad Zafar
Lecturer (SL)
fawad.zafar@iba-suk.edu.pk

Nasir Ali
Lecturer
}


Media & Communication

{
Syed Hassan Ali
Associate Professor and HOD
hassan.ali@iba-suk.edu.pk

Ahmed Ali
Lecturer BPS 18
ahmed_ali@iba-suk.edu.pk
}


Physical Education

{
Shahzaman Khan
HOD/Assistant Professor
shahzaman@iba-suk.edu.pk

Mohammad Hashim Draya
Lecturer
m.hashim@iba-suk.edu.pk

Nisar Ahmed Khaskheli
Lecturer
nisar.khaskheli@iba-suk.edu.pk

Asad Hussain Shaikh
Deputy Director Sports
asad.hussain@iba-suk.edu.pk

Gul Habib
Athletic Demonstrator
gul.habib@iba-suk.edu.pk

Zubair Ahmed Kaloi
Gymnastic Demonstrator
zubair-ahmed@iba-suk.edu.pk

Syed Tasadaque A. Shah
Associate Professor
tasadaque.shah@iba-suk.edu.pk
Faculty
All PhDs
Management Science
Computer Science
Electrical Engineering
Computer System Engineering
Education
Mathematics
Support Faculty
Our Professors
All PhDs
Follow us: 



Contact Us
Sukkur IBA University
Nisar Ahmed Siddiqui Road

Sukkur Sindh, Pakistan
Telephone: 071-5644000 / 05
Email: info@iba-suk.edu.pk

}



Finance  Marketing & Operations Management  HRM  Economics
Finance

{
Altaf Hussain Samo
Professor / Director EDC
altaf@iba-suk.edu.pk

Agha Jahanzeb
Assistant Professor
agha.jahanzeb@iba-suk.edu.pk

Tariq Aziz
Assistant Professor (Lien)
tariq.aziz@iba-suk.edu.pk

Mujeeb-u-Rehman Bhayo
Assistant Professor & Director IA
mujeeb@iba-suk.edu.pk

Pervaiz Memon
Professor
pervaiz@iba-suk.edu.pk

Raja Shahzad Shaikh
Assistant Professor
shahzad@iba-suk.edu.pk

Abdul Khaliq Daudpota
Assistant Professor (SL)
khaliq@iba-suk.edu.pk

Hyder Ali Khawaja
Assistant Professor
hyderali@iba-suk.edu.pk

Mulazim Ali Khokhar
Assistant Professor
mulazim.ali@iba-suk.edu.pk

Naveed Qureshi
Assistant Professor
naveed@iba-suk.edu.pk

Sonia Kumari
Lecturer
sonia.kumari@iba-suk.edu.pk

Sajjad Ahmed
Lecturer
sajjad.ahmed@iba-suk.edu.pk

Ume Salma Akbar
Assistant Professor
u.salma@iba-suk.edu.pk

Shujaat Ali
Assistant Professor of Practice
shujaatali@iba-suk.edu.pk

Muhammad Shaique
Assistant Professor
shaiq@iba-suk.edu.pk

Sahibzada Muhammad Wasim Jan
Assistant Professor,Law
wasimjan@iba-suk.edu.pk

Shahbaz Makhdoom, ACCA
Lecturer (SL)

Ranjeeta
Lecturer (Study Leave)
ranjeeta@iba-suk.edu.pk

Abid ullah
Assistant Professor
abidullah@iba-suk.edu.pk

Vikesh Kumar
Lecturer (Study Leave)
vikeshkumar@iba-suk.edu.pk

Rakesh Kumar
Lecturer
kumar.rakesh@iba-suk.edu.pk
Ghulam Abbas
Associate Professor
g_abbas@iba-suk.edu.pk
Ameet Kumar
Lecturer (SL)
ammeet.kumar@iba-suk.edu.pk
}`